import { make } from 'vuex-pathify';
import { DelinquencyGraceDaysService } from '@/modules/global-settings/delinquency/services/grace-days.service';
import Logger from '@/lib/logger.js';

const service = new DelinquencyGraceDaysService();

// --- STATE ---
export const state = {
  /**
   * FIX: Initialize the state with the correct object structure.
   * This ensures that `.data` and `.pagination` exist from the very beginning,
   * preventing the "undefined" error on initial render.
   */
  factorSetups: {
    data: [],
    pagination: {},
  },
  actionOutcomes: {
    data: [],
    pagination: {},
  },
  closedCaseSettings: {
    data: [],
    pagination: {},
  },
};

// --- MUTATIONS ---
// vuex-pathify automatically creates the necessary mutations (e.g., SET_ACTION_OUTCOMES)
export const mutations = {
  ...make.mutations(state),
};

// --- GETTERS ---
export const getters = {
  ...make.getters(state),
};

// --- ACTIONS ---
export const actions = {
  // --- Factor Setup Actions ---
  async getFactorSetups({ commit }, params) {
    try {
      const { data } = await service.getFactorSetups(params);
      // Committing the entire response payload { data: [], pagination: {} }
      commit('SET_FACTOR_SETUPS', data);
      return data;
    } catch (error) {
      Logger.error('Getting Grace Days Factor Setup', error);
      throw error;
    }
  },

  async createFactorSetup(_, payload) {
    try {
      const { data } = await service.createFactorSetup(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Grace Days Factor Setup', error);
      throw error;
    }
  },

  async updateFactorSetup(_, { id, payload }) {
    try {
      const { data } = await service.updateFactorSetup(id, payload);
      return data;
    } catch (error) {
      Logger.error('Updating Grace Days Factor Setup', error);
      throw error;
    }
  },

  async deleteFactorSetup(_, id) {
    try {
      const { data } = await service.deleteFactorSetup(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Grace Days Factor Setup', error);
      throw error;
    }
  },

  // --- Action Outcome Actions ---
  async getActionOutcomes({ commit }, params) {
    try {
      const { data } = await service.getActionOutcomes(params);
      commit('SET_ACTION_OUTCOMES', data);
      return data;
    } catch (error) {
      Logger.error('Getting Grace Days Action Outcomes', error);
      throw error;
    }
  },

  async createActionOutcome(_, payload) {
    try {
      const { data } = await service.createActionOutcome(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Grace Days Action Outcome', error);
      throw error;
    }
  },

  async updateActionOutcome(_, { id, payload }) {
    try {
      const { data } = await service.updateActionOutcome(id, payload);
      return data;
    } catch (error) {
      Logger.error('Updating Grace Days Action Outcome', error);
      throw error;
    }
  },

  async deleteActionOutcome(_, id) {
    try {
      const { data } = await service.deleteActionOutcome(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Grace Days Action Outcome', error);
      throw error;
    }
  },

  // --- Closed Case Settings Actions ---
  async getClosedCaseSettings({ commit }, params) {
    try {
      const { data } = await service.getClosedCaseSettings(params);
      commit('SET_CLOSED_CASE_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('Getting Grace Days Closed Case Settings', error);
      throw error;
    }
  },

  async createClosedCaseSettings(_, payload) {
    try {
      const { data } = await service.createClosedCaseSettings(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Grace Days Closed Case Settings', error);
      throw error;
    }
  },

  async updateClosedCaseSettings(_, { id, payload }) {
    try {
      const { data } = await service.updateClosedCaseSettings(id, payload);
      return data;
    } catch (error) {
      Logger.error('Updating Grace Days Closed Case Settings', error);
      throw error;
    }
  },

  async deleteClosedCaseSettings(_, id) {
    try {
      const { data } = await service.deleteClosedCaseSettings(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Grace Days Closed Case Settings', error);
      throw error;
    }
  },
};